import { StrictMode, useRef } from 'react'
import { createRoot } from 'react-dom/client'
import { createRouter, RouterProvider } from '@tanstack/react-router'
import '@tandem/ui/typebase.css'
import './global.css'
import { TRPCProvider } from './trpc'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import { ToastProvider, useToast } from '@tandem/ui/Toast'
import { routeTree } from './routeTree.gen'
import * as z from "zod"
import { ru } from "zod/locales"
import { QueryClientProvider } from '@tanstack/react-query'
import { getQueryClient, trpcClient } from './trpc'

z.config(ru())

window.addEventListener('vite:preloadError', () => {
  window.location.reload()
})

const router = createRouter({
  routeTree,
  context: {
    auth: undefined!,
  },
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

function App() {
  let toast = useToast()
  let toastRef = useRef(toast)
  toastRef.current = toast
  let queryClient = getQueryClient(toastRef)
  return (
    <QueryClientProvider client={queryClient}>
      <TRPCProvider trpcClient={trpcClient} queryClient={queryClient}>
        <AuthProvider>
          <Router />
        </AuthProvider>
      </TRPCProvider>
    </QueryClientProvider>
  )
}

function Router() {
  let auth = useAuth()
  return (
    <RouterProvider
      router={router}
      context={{
        auth: {
          isAuthenticated: auth.isAuthenticated,
          isLoading: auth.isLoading,
        },
      }}
    />
  )
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ToastProvider>
      <App />
    </ToastProvider>
  </StrictMode>,
)
